<template>
  <div class="wlx-unified-login-wrapper">
    <div class="login-hade-tab clearfix">
      <div
        class="user-account-login"
        @click="switchTab('account')"
        :class="{'active_login' : isTab == 'account'}"
      >
        <span style="float:left">账号登录</span>
      </div>
    </div>
    <div class="login-form-input clearfix">
      <el-form ref="form" :model="ruleForm" :rules="rules">
        <div class="from-account-login" v-show="isTab == 'account'">
          <el-form-item prop="userName">
            <el-input placeholder="请输入账号" prefix-icon="wl-icon-user" v-model="ruleForm.userName"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              placeholder="请输入密码"
              prefix-icon="wl-icon-mimaicon"
              v-model="ruleForm.password"
              type="password"
              @keyup.enter.native="login()"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button v-if="isTab == 'account'" type="primary" @click="login">登录</el-button>
          <el-button v-if="isTab == 'phone'" type="primary" @click="Phonelogin()">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import redirect from "api/v1.commom.login.ts";
export default {
  data() {
    return {
       show1: true,
      show2: false,
      show3: false,
       isTab: "account",
      isRoleTab: "1",
      isShow: false,
      ruleForm: {
        userName: "",
        password: "",
        phone: "",
        captcha: ""
      },
      rules: {
        userName: [
          { required: true, message: "请输入用户账号", trigger: "change" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" }
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "change" }],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "change" }
        ]
      }
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    },
    association: function() {
      return this.$store.state.association;
    }
  },
  watch: {
    association: {
      handler(val) {
        document.title = val.associationName;
        this.getBanner();
        this.wlxLogo = val.Logo;
      },
      deep: true
    }
  },
  methods: {
    switchTab(content) {
      this.isTab = content;
    },
    login: function() {
      var that = this;
      this.loadingTip(true);
      this.$http
        .post("/api/XOrg/XLogin/Accountlogin", {
          userName: that.ruleForm.userName,
          userPwd: that.ruleForm.password,
          associationId: that.association.Id
        })
        .then(function(rst) {
          if (rst && rst.code > 0) {
            if (rst.code === 1) {
              localStorage["userName"] = that.ruleForm.userName;
              localStorage["userId"] = rst.userId;
            }
            that.$store.dispatch(MU_UPATE_AUTH).then(rt => {
              that.loadingTip(false);
              // 登录完获取回登录信息跳转
              that.scanVisible = false;
            });
          } else {
            that.loadingTip(false);
            that.$message.warning(rst.msg);
          }
        });
    },
    //手机登录
    Phonelogin() {
      var that = this;
      this.loadingTip(true);
      this.$http
        .post("/api/XOrg/XLogin/Phonelogin", {
          phone: that.ruleForm.phone,
          captcha: that.ruleForm.captcha,
          associationId: that.association.Id
        })
        .then(rst => {
          if (rst && rst.code > 0) {
            if (rst.code === 1) {
              localStorage["userName"] = that.ruleForm.userName;
              localStorage["userId"] = rst.userId;
            }
            that.$store.dispatch(MU_UPATE_AUTH).then(rt => {
              that.loadingTip(false);
              // 登录完获取回登录信息跳转
              that.scanVisible = false;
            });
          } else {
            that.loadingTip(false);
            that.$message.warning(rst.msg);
          }
        });
    },
    loadingTip(is) {
      // let loading = null;
      if (is) {
        this.$loading({
          lock: true,
          text: "正在登录..."
        });
      } else {
        this.$loading({}).close();
      }
    },
    enterRegister(){
      this.$router.push({
        name:'register'
      });
    }
  }
};
</script>

<style lang="scss">
.wlx-unified-login-wrapper {
  .login-role-tab {
    position: absolute;
    right: -94px;
    top: 0;
    .login-role-tab-li {
      width: 94px;
      height: 40px;
      background: rgba(51, 51, 51, 0.5);
      color: #fff;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .active_role {
      background: #333333;
    }
  }
  .login-hade-tab {
    font-size: 18px;
    color: #bcbcbc;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    .user-account-login {
      float: left;
      width: 100%;
      border-bottom: 2px solid #e2e1e1;
    }
    // .user-phone-login {
    //     float: left;
    //     width: 50%;
    //     border-bottom: 2px solid #E2E1E1;
    // }
    .active_login {
      color: #333;
      border-color: #297efd;
      float: left;
    }
  }
  .login-form-input {
    margin-top: 35px;
    .go-register-right {
      float: right;
      color: #297efd;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
      i {
        font-size: 22px;
        vertical-align: -3px;
      }
    }
    .captcha-phone-input {
      float: left;
      width: 266px;
    }
    .captcha-phone-button {
      float: right;
      width: 138px;
      font-size: 14px;
    }
  }
  .p-enter-resiger{
    text-align: right;
    color: #3C8AFD;
    cursor: pointer;
  }
}
</style>
